import {OnInit, Component, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule, Router} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import { PRODUCT_TS } from '../../MainComponent';

@Component({
    selector: 'setting',
    templateUrl: "../../../../views/components/app/home/setting.html",
    providers: []
})
export class Setting implements OnInit {

    PRODUCT: any;
    
    constructor(private router: Router) {
        this.PRODUCT = PRODUCT_TS;
    }

    ngOnInit(){
    }
}

@NgModule({
    declarations: [Setting],
    imports: [FormsModule, BrowserModule, RouterModule],
    providers: [],
    entryComponents: [],
    exports: [Setting]
})
export class SettingModule{
}